<template>
  <section class="cw-row">
    <div class="cw-header">
      <h2>Continue assistindo</h2>
    </div>
    <div class="cw-scroller" ref="scroller">
      <ContinueWatchingCard
        v-for="lo in learningObjects"
        :key="lo.enrollId + ':' + lo.loId"
        :learning-object="lo"
        @play="$emit('play', $event)"
      />
    </div>
  </section>
</template>

<script>
import ContinueWatchingCard from './ContinueWatchingCard.vue';

export default {
  name: 'ContinueWatchingRow',
  components: { ContinueWatchingCard },
  props: {
    learningObjects: { type: Array, default: () => [] }
  }
};
</script>

<style scoped lang="scss">
.cw-row {
  margin: 4px 0 18px;
}

.cw-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px 10px;

  h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--md-text);
  }
}

.cw-scroller {
  display: flex;
  gap: 10px;
  padding: 0 18px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  scroll-snap-type: x proximity;

  &::-webkit-scrollbar { display: none; }
  & > * { scroll-snap-align: start; }
}
</style>
